import {i18n} from "@/i18n";
import {mapActions} from "vuex";

export const common_funcs = {
    methods: {
        show_error_message: function (error) {
            let section = error.response.data.section
            let message = error.response.data.message
            this.show_translated_error_snackbar(section, message)
        },
        show_translated_error_snackbar: function (section, message) {
            this.setSnackbar({
              text: i18n.t(`notifications.${section}.${message}`),
              timeout: 5000,
            })
        },
        send_system_reload_message: function () {
            let msg = {method: 'system_reload', params: ''}
            this.sendSocketMessage(msg)
        },
        normilize_license_plate: function (license_plate) {
            let good_chars = this.$store.state.chars_transcription.good_chars
            let chars_substitute = this.$store.state.chars_transcription.chars_substitute
            let result = ''
            let unknown_char_found = false
            for (let c of license_plate) {
                if (good_chars.includes(c)) {
                    result += c
                } else if (c in chars_substitute) {
                    result += chars_substitute[c]
                } else {
                    unknown_char_found = true
                    break
                }
            }
            if (unknown_char_found) {
                return license_plate
            } else {
                return result
            }
        },
        set_system_params: function (system_params_dict, result_msg_code) {
          let data = {params: system_params_dict}
          this.$http({
            url: this.$http_hostname + '/system_settings/set_config_params',
            data: data,
            method: 'POST'
          })
          .then(() => {
              switch (result_msg_code) {
                  case 'system_reboot_required':
                    this.setSnackbar({
                    text: 'PH: Изменения сохранены' + ". " +
                          i18n.t('general.system_reboot_required')
                    });
                    break;
                  case 'device_restart_required':
                    this.setSnackbar({
                    text: 'PH: Изменения сохранены' + ". " +
                          i18n.t('general.device_restart_required')
                    })
                    break;
                  case 'changes_saved':
                    this.setSnackbar({
                    text: 'PH: Изменения сохранены.'
                    });
                    break;
              }
            this.updateSystemParams(system_params_dict)
          })
          .catch(error => {
            console.log(error)
          })
        },
        ...mapActions(['setSnackbar', 'updateLoadingOverlay', 'sendSocketMessage', 'updateSystemParams']),
    }
}